module.exports = __webpack_public_path__ + "components/location-nav/static/icon-caret-down-f4ed7221b91006b585c1ca632502f73f.svg";